import React, { PureComponent } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Container } from 'reactstrap'
import {
  SubmitVerify,
  ProgresVerify as ProgressVerify,
  SubmitPhone,
  SubmitPhoneV2
} from './MainField'
import {
  REQUEST_TO_BE_SELLER, NEW_REQUEST_TO_BE_SELLER
} from '../../../utils/Constants';
import SellerVerification from "../SellerVerification"

class VerifyOtp extends PureComponent {

  _mainField = () => {
    let { submitPhone, submitVerify, sentSMS, newSubmitPhone, insertPassword, setDataPhone } = this.props.onClick
    let { userPhone: { dataPhoneUser, isSubmitPhoneSale, dataVerify, isVerify } } = this.props.onData
    const { isVerifiedAlready, setIsVerifiedAlready } = this.props;
    // if (!dataPhoneUser.data && !isSubmitPhoneSale)
      return (
        <SubmitPhoneV2
          onClick={insertPassword}
          setPhonePayload={setDataPhone}
          {...dataPhoneUser}
          onUnverified={this.props.onUnverified}
          isSubmit={this.props.isSubmit}
          doRefreshToken={this.props.doRefreshToken} 
          doVerifyOtp={this.props.doVerifyOtp} 
          doSentCitCall={this.props.doSentCitCall} 
          doSentSMS={this.props.doSentSMS} 
          doSubmitPhone={this.props.doSubmitPhone} 
          isOpen={this.props.isOpen}
          toggleModalSellerVerification={this.props.toggleModalSellerVerification}
          isVerifiedAlready={isVerifiedAlready}
          setIsVerifiedAlready={setIsVerifiedAlready}
        />
      )
  }

  render() {
    return (
      <Container className="sell-request-form-container">
        <div className="header-otp">
          <p>{NEW_REQUEST_TO_BE_SELLER}</p>
        </div>
        {this._mainField()}
      </Container>
    )
  }
}

export default VerifyOtp